<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-overlay :value="isLoadingActions">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col cols="12" sm="6">
        <v-file-input
          accept=".xlsx"
          v-model="selectFixXlsx"
          label="Bấm để chọn file (SỬA CHỮA)"
        ></v-file-input
      ></v-col>
      <v-col cols="12" sm="6">
        <v-btn color="primary" @click="uploadXlsxSuaChua" class="mt-3">Upload</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-file-input
          accept=".xlsx"
          v-model="selectBuyXlsx"
          label="Bấm để chọn file (BẢO HÀNH)"
        ></v-file-input
      ></v-col>
      <v-col cols="12" sm="6">
        <v-btn color="primary" @click="uploadXlsxBaoHanh" class="mt-3">Upload</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { mapState } from "vuex";

export default {
  name: "NotificationList",
  data() {
    return {
      selectFixXlsx: null,
      selectBuyXlsx: null,
      isLoadingActions: false,
    };
  },

  methods: {
    async uploadXlsxSuaChua() {
      this.isLoadingActions = true;
      if (!this.selectFixXlsx) {
        return;
      }
      if (this.selectFixXlsx) {
        try {
          var formData = new FormData();
          formData.append("suachuaexcel", this.selectFixXlsx);
          await this.$services.phonefixService.uploadExcelFile(formData);
        } catch (err) {
          console.log(err);
        } finally {
          this.isLoadingActions = false;
        }
      }
      this.selectFixXlsx = null;
    },
    async uploadXlsxBaoHanh() {
      this.isLoadingActions = true;
      if (!this.selectBuyXlsx) {
        return;
      }
      if (this.selectBuyXlsx) {
        try {
          var formData = new FormData();
          formData.append("baohanhexcel", this.selectBuyXlsx);
          await this.$services.phonebuyService.uploadExcelFile(formData);
        } catch (err) {
          console.log(err);
        } finally {
          this.isLoadingActions = false;
        }
      }
      this.selectBuyXlsx = null;
    },
  },
};
</script>
